import { makeStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import blueGrey from '@material-ui/core/colors/blueGrey';
const useStyles = makeStyles(theme => ({

    container: {
        // marginTop: theme.spacing(8),
        padding: theme.spacing(2),
        //  textAlign: 'center'
    },
    iconLeft: {
        position: 'absolute',
        marginLeft: '-75px',
        fontSize: '65px',
        marginTop: '-17px',
        color: '#ffffff85'
    },
    iconRight: {
        marginLeft: theme.spacing(1)
    },
    imgResponsive: {
        width: "100%"
    },
    progressKerja: {
        // backgroundColor: green[500],
        padding: "1.25rem",
        color: "black"
    },
    wilayahKerja: {
        // backgroundColor: red[500],
        padding: "1.25rem",
        color: "black"
    },
    floatRightIcon: {
        float: 'right'
    },
    floatLeftIcon: {
        float: 'left'
    },
    blueGreyBackground: {
        padding: "1.25rem",
        color: "#fff",
        textAlign: 'center',
        width: "100%",
        boxShadow: 'rgba(0, 0, 0, 0.15) 0px 3px 3px 0px'
    },

    fullWidth: {
        width: "100%"
    }

}))

export default useStyles;